import { FC, useCallback, useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import { useDropzone, DropzoneOptions } from 'react-dropzone';
import styled from 'styled-components';

//Constants
import { FontFamilyBold, FontFamilyRegular } from '../../constants';
import { toast } from 'react-toastify';

// Define Interface
type Props = {
  className?: string;
  accept?: string;
  setPhoto: (args: File) => void;
} & DropzoneOptions;

interface StyledCompProps {
  fontFamilyBold?: string;
  fontFamilyRegular?: string;
}

const StyledComponent = styled.div<StyledCompProps>``;
StyledComponent.defaultProps = {
  fontFamilyBold: FontFamilyBold,
  fontFamilyRegular: FontFamilyRegular,
};

const CustomDropzone: FC<Props> = ({
  setPhoto,
  children,
  accept,
  className,
  ...props
}) => {
  const onDrop = useCallback((acceptedFiles, fileRejections) => {
    acceptedFiles.forEach((file) => {
      setPhoto(file);
    });
    if (fileRejections.length > 0) {
      toast.error(
        fileRejections?.[0]?.errors?.[0]?.message ??
          'Error uploading file, please choose another image',
        {
          position: 'top-right',
          autoClose: 3000,
          closeOnClick: true,
          pauseOnHover: true,
        },
      );
    }
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    accept,
    onDrop,
    maxSize: 5242880,
    ...props,
  });

  return (
    <StyledComponent className={className} {...getRootProps()}>
      <input {...getInputProps()} />
      {children}
    </StyledComponent>
  );
};
CustomDropzone.defaultProps = {
  className: '',
  accept: 'image/png, image/jpeg, image/jpg',
};

export default CustomDropzone;
